import React, { useEffect, useState, useRef } from 'react';

export const ImpactStatsSection = () => {
  const [stats, setStats] = useState({
    members: 0,
    womenReached: 0,
    cities: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          animateStats();
          setHasAnimated(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const animateStats = () => {
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;

    let currentStep = 0;
    const interval = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setStats({
        members: Math.floor(1900 * progress),
        womenReached: Math.floor(195000 * progress),
        cities: Math.floor(25 * progress)
      });

      if (currentStep >= steps) {
        clearInterval(interval);
        setStats({ members: 1900, womenReached: 195000, cities: 25 });
      }
    }, stepDuration);
  };

  return (
    <section 
      id="impact-stats" 
      ref={sectionRef}
      className="py-16" 
      style={{ backgroundColor: 'var(--pink-blush)' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center md:border-r md:border-[var(--pink-dusty)]">
            <div className="text-5xl md:text-6xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              {stats.members.toLocaleString()}+
            </div>
            <div className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Lady Hustlers Worldwide
            </div>
          </div>
          
          <div className="text-center md:border-r md:border-[var(--pink-dusty)]">
            <div className="text-5xl md:text-6xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              {stats.womenReached.toLocaleString()}+
            </div>
            <div className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Women Reached Globally
            </div>
          </div>
          
          <div className="text-center">
            <div className="text-5xl md:text-6xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              {stats.cities}+
            </div>
            <div className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Countries
            </div>
          </div>
        </div>

        {/* Credentials Strip */}
        <div className="text-center">
          <p className="lhsc-subheading text-xs leading-relaxed" style={{ color: 'var(--slate-grey)' }}>
            FEDERALLY REGISTERED NONPROFIT · MONTREAL, CANADA<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            LISTED ON THE UN PARTNER PORTAL<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            GOOGLE FOR NONPROFITS
          </p>
        </div>
      </div>
    </section>
  );
};
